// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kumbh+Sans:wght@300;700&family=Roboto+Slab:wght@300;700&family=Space+Mono:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  border: 0;
}

*, *:before, *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

:focus, :active {
  outline: none;
}

a:focus, a:active {
  outline: none;
}

nav, footer, header, aside {
  display: block;
}

html, body {
  height: 100%;
  width: 100%;
  font-size: 100%;
  line-height: 1;
  font-size: 14px;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

input, button, textarea {
  font-family: inherit;
}

input::-ms-clear {
  display: none;
}

button {
  cursor: pointer;
  background-color: unset;
}

button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

a, a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

ul li {
  list-style: none;
}

img {
  vertical-align: top;
}

h1, h2, h3, h4, h5, h6 {
  font-size: inherit;
  font-weight: 400;
}

/*--------------------*/
h1 {
  font-size: 100px;
  font-weight: 700;
  line-height: 120px;
  letter-spacing: -5px;
}

h2 {
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
}

h3 {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 15px;
  text-transform: uppercase;
  margin-left: 15px;
}

h4 {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 5px;
  text-transform: uppercase;
}

p.regular {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

p.small {
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
}

body {
  background-color: #1E213F;
  color: #D7E0FF;
}

.container {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container.red .tab-active-bg {
  background-color: #F87070;
}
.container.red .timer-inner button:hover {
  color: #F87070;
}
.container.cyan .tab-active-bg {
  background-color: #70F3F8;
}
.container.cyan .timer-inner button:hover {
  color: #70F3F8;
}
.container.purple .tab-active-bg {
  background-color: #D881F8;
}
.container.purple .timer-inner button:hover {
  color: #D881F8;
}
.container.kumbh-sans {
  font-family: "Kumbh Sans", sans-serif;
}
.container.kumbh-sans button {
  font-family: "Kumbh Sans", sans-serif;
}
.container.roboto-slab {
  font-family: "Roboto Slab", serif;
}
.container.roboto-slab button {
  font-family: "Roboto Slab", serif;
}
.container.space-mono {
  font-family: "Space Mono", monospace;
}
.container.space-mono h1 {
  font-weight: 400;
}
.container.space-mono p.regular {
  font-size: 13px;
}
.container.space-mono button {
  font-family: "Space Mono", monospace;
}

.logo {
  color: #D7E0FF;
  font-family: "Kumbh Sans", sans-serif;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin: 48px auto 55px;
}

.tabs {
  display: flex;
  margin-bottom: 45px;
  text-align: center;
  background-color: #161932;
  border-radius: 50px;
  border: 8px #161932 solid;
  position: relative;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  z-index: 1;
}

.tab-active-bg {
  width: 120px;
  height: 48px;
  position: absolute;
  z-index: 0;
  border-radius: 50px;
  transition: 0.3s;
}

.tab {
  width: 120px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
  opacity: 0.4;
  color: #D7E0FF;
  transition: 0.3s;
}
.tab.active {
  opacity: 1;
  color: #1E213F;
}
.tab:hover {
  opacity: 1;
}

.timer-outer {
  position: relative;
  width: 410px;
  height: 410px;
  color: #D7E0FF;
  margin-bottom: 63px;
  border-radius: 410px;
  background: linear-gradient(315deg, #2E325A 0%, #0E112A 100%);
  box-shadow: 50px 50px 100px 0px #121530, -50px -50px 100px 0px #272C5A;
}

@keyframes dash {
  to {
    stroke-dashoffset: 1000;
  }
}
.timer-inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 366px;
  height: 366px;
  border-radius: 366px;
  background: #161932;
  text-align: center;
}
.timer-inner h1 {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  user-select: none;
}
.timer-inner button {
  color: #D7E0FF;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(300%);
}
.timer-inner svg {
  transition: 0.3 linear;
  position: relative;
  height: 100%;
  width: 100%;
  stroke-width: 11px;
  stroke-linecap: round;
  fill-opacity: 0%;
  transform: rotate(-90deg);
}
.timer-inner svg.red {
  stroke: #F87070;
}
.timer-inner svg.cyan {
  stroke: #70F3F8;
}
.timer-inner svg.purple {
  stroke: #D881F8;
}

.settings-icon {
  transition: 0.3s;
}
.settings-icon:hover {
  filter: brightness(1.1);
  cursor: pointer;
}

.gray {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(10, 12, 28, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  padding: 24px;
}

.settings {
  background-color: #FFFFFF;
  border-radius: 25px;
  color: #161932;
  width: 540px;
  position: relative;
}
.settings button {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateY(50%) translateX(-50%);
  color: #FFFFFF;
  background-color: #F87070;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  padding: 16px;
  min-width: 140px;
  border-radius: 30px;
  transition: 0.3s;
}
.settings button:hover {
  background-color: #f97f7f;
}

.header {
  padding: 34px 40px 31px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E3E1E1;
}
.header img {
  padding: 10px;
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
.header img:hover {
  opacity: 1;
}

.setting-container {
  padding: 24px 40px 60px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.input-group {
  display: flex;
  gap: 20px;
  margin-top: 22px;
}
.input-group label p {
  opacity: 0.4;
  padding-bottom: 8px;
}

.horizontal-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.radio-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.radio {
  width: 40px;
  height: 40px;
  background-color: #EFF1FA;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  cursor: pointer;
  position: relative;
  color: hsla(235, 35%, 18%, 0.72);
  transition: 0.3s;
}
.radio::before {
  content: "";
  width: 50px;
  height: 50px;
  position: absolute;
  left: -5px;
  top: -5px;
  border-radius: 50px;
  border: 1px solid #EFF1FA;
  opacity: 0;
}
.radio.red {
  background-color: #F87070;
}
.radio.cyan {
  background-color: #70F3F8;
}
.radio.purple {
  background-color: #D881F8;
}
.radio.kumbh-sans {
  font-family: "Kumbh Sans", sans-serif;
  font-weight: 700;
}
.radio.roboto-slab {
  font-family: "Roboto Slab", serif;
  font-weight: 400;
}
.radio.space-mono {
  font-family: "Space Mono", monospace;
  font-weight: 700;
}
.radio.active.font {
  background-color: #161932;
  color: #FFFFFF;
  user-select: none;
}
.radio.active.color::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.radio:hover::before {
  opacity: 1;
}

input[type=number] {
  border-radius: 10px;
  background: #EFF1FA;
  height: 48px;
  width: 100%;
  padding: 16px;
  color: #1E213F;
  font-size: 14px;
  font-weight: 700;
}

.divider {
  opacity: 0.1;
  background: #1E213F;
  width: 100%;
  height: 1px;
}

.hidden {
  display: none;
}

@media screen and (max-width: 768px) {
  h1 {
    font-size: 80px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 14px;
  }
  h4 {
    text-align: center;
  }
  p.regular {
    font-size: 12px;
  }
  .container.space-mono {
    font-family: "Space Mono", monospace;
  }
  .container.space-mono h1 {
    font-weight: 400;
    font-size: 70px;
  }
  .container.space-mono p.regular {
    font-size: 13px;
  }
  .container.space-mono button {
    font-family: "Space Mono", monospace;
  }
  .timer-outer {
    position: relative;
    width: 300px;
    height: 300px;
  }
  .tab {
    width: 105px;
  }
  .tab-active-bg {
    width: 105px;
  }
  .timer-inner {
    width: 267px;
    height: 267px;
  }
  .timer-inner h1 {
    transform: translateX(-50%) translateY(-60%);
  }
  .timer-inner button {
    transform: translateX(-50%) translateY(180%);
  }
  .header {
    padding: 24px 24px 28px;
  }
  .input-group {
    flex-direction: column;
    align-items: center;
  }
  .input-group label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .input-group label input {
    max-width: 50%;
  }
  .horizontal-group {
    flex-direction: column;
    gap: 18px;
  }
}/*# sourceMappingURL=styles.css.map */`, "",{"version":3,"sources":["webpack://./src/scss/_zeroing.scss","webpack://./src/css/styles.css","webpack://./src/scss/styles.scss","webpack://./src/scss/_responsive.scss"],"names":[],"mappings":"AACA;EACC,UAAA;EACA,SAAA;EACA,SAAA;ACCD;;ADCA;EACC,2BAAA;EACA,8BAAA;EACA,sBAAA;ACED;;ADAA;EAAe,aAAA;ACIf;;ADHA;EAAiB,aAAA;ACOjB;;ADLA;EAAwB,cAAA;ACSxB;;ADPA;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;ACUD;;ADRA;EAAsB,oBAAA;ACYtB;;ADVA;EAAiB,aAAA;ACcjB;;ADbA;EAAO,eAAA;EAAiB,uBAAA;ACkBxB;;ADjBA;EAA0B,UAAA;EAAU,SAAA;ACsBpC;;ADrBA;EAAa,qBAAA;ACyBb;;ADxBA;EAAQ,qBAAA;AC4BR;;AD3BA;EAAM,gBAAA;AC+BN;;AD9BA;EAAI,mBAAA;ACkCJ;;ADhCA;EAAkB,kBAAA;EAAkB,gBAAA;ACqCpC;;ADpCA,uBAAA;AErBA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AD6DJ;;AC1DA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AD6DJ;;AC1DA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AD6DJ;;AC1DA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AD6DJ;;AC1DA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AD6DJ;;AC1DA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AD6DJ;;AC1DA;EACI,yBArDQ;EAsDR,cAlDQ;AD+GZ;;ACzDA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AD4DJ;ACxDQ;EACI,yBAhEN;AD0HN;ACvDgB;EACI,cApEd;AD6HN;ACpDQ;EACI,yBA3EL;ADiIP;ACnDgB;EACI,cA/Eb;ADoIP;AChDQ;EACI,yBAtFH;ADwIT;AC/CgB;EACI,cA1FX;AD2IT;AC5CI;EACI,qCAAA;AD8CR;AC7CQ;EACI,qCAAA;AD+CZ;AC5CI;EACI,iCAAA;AD8CR;AC7CQ;EACI,iCAAA;AD+CZ;AC5CI;EACI,oCAAA;AD8CR;AC7CQ;EACI,gBAAA;AD+CZ;AC7CQ;EACI,eAAA;AD+CZ;AC7CQ;EACI,oCAAA;AD+CZ;;AC1CA;EACI,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AD6CJ;;AC1CA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAxIG;EAyIH,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AD4CJ;;ACzCA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAhJS;AD4Lb;;ACzCA;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAhKQ;EAiKR,gBA7JS;ADyMb;AC1CI;EACI,UAAA;EACA,cAzKI;ADqNZ;ACzCI;EACI,UAAA;AD2CR;;ACvCA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAjLQ;EAkLR,mBAAA;EAEA,oBAAA;EACA,6DAAA;EACA,sEAAA;ADyCJ;;ACtCA;EACI;IACE,uBAAA;EDyCJ;AACF;ACtCA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,mBA5MG;EA6MH,kBAAA;ADwCJ;ACrCI;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,iBAAA;ADuCR;ACpCI;EACI,cArNI;EAsNJ,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;ADsCR;ACnCI;EACI,sBAAA;EACA,kBAAA;EAGA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;ADmCR;ACjCQ;EACI,eA1ON;AD6QN;ACjCQ;EACI,eA9OL;ADiRP;ACjCQ;EACI,eAlPH;ADqRT;;AC9BA;EACI,gBAjPS;ADkRb;AChCI;EACA,uBAAA;EACA,eAAA;ADkCJ;;AC9BA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;ADiCJ;;AC9BA;EACI,yBAvQI;EAwQJ,mBAAA;EACA,cAhRG;EAiRH,YAAA;EACA,kBAAA;ADiCJ;AC/BI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2CAAA;EACA,cAlRA;EAmRA,yBAtRF;EAwRE,kBAAA;EACA,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,gBAAA;EACA,mBAAA;EAEA,gBA3RK;ADyTb;AC5BQ;EACI,yBAAA;AD8BZ;;ACzBA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AD4BJ;AC1BI;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBA9SK;AD0Ub;AC1BQ;EACI,UAAA;AD4BZ;;ACvBA;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AD0BJ;;ACvBA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AD0BJ;ACxBI;EACI,YAAA;EACA,mBAAA;AD0BR;;ACtBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ADyBJ;;ACtBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;ADyBJ;;ACtBA;EACI,WAAA;EACA,YAAA;EACA,yBA3VS;EA4VT,mBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EAEA,gBAnWS;AD0Xb;ACrBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;ADuBR;ACpBI;EACI,yBAvXF;AD6YN;ACnBI;EACI,yBA5XD;ADiZP;AClBI;EACI,yBAjYC;ADqZT;ACjBI;EACI,qCAAA;EACA,gBAAA;ADmBR;ACjBI;EACI,iCAAA;EACA,gBAAA;ADmBR;ACjBI;EACI,oCAAA;EACA,gBAAA;ADmBR;ACfQ;EACI,yBArZL;EAsZK,cA/YJ;EAgZI,iBAAA;ADiBZ;ACfQ;EACI,gDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;ADiBZ;ACXI;EACI,UAAA;ADaR;;ACTA;EACI,mBAAA;EACA,mBAtaS;EAuaT,YAAA;EACA,WAAA;EACA,aAAA;EAEA,cAhbQ;EAibR,eAAA;EACA,gBAAA;ADWJ;;ACRA;EACI,YAAA;EACA,mBAvbQ;EAwbR,WAAA;EACA,WAAA;ADWJ;;ACRA;EACI,aAAA;ADWJ;;AE5cA;EACI;IACI,eAAA;EF+cN;EE5cE;IACI,eAAA;EF8cN;EE3cE;IACI,eAAA;EF6cN;EE1cE;IACI,kBAAA;EF4cN;EEzcE;IACI,eAAA;EF2cN;EEvcM;IACI,oCAAA;EFycV;EExcU;IACI,gBAAA;IACA,eAAA;EF0cd;EExcU;IACI,eAAA;EF0cd;EExcU;IACI,oCAAA;EF0cd;EErcE;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EFucN;EEpcE;IACI,YAAA;EFscN;EEncE;IACI,YAAA;EFqcN;EElcE;IACI,YAAA;IACA,aAAA;EFocN;EElcM;IACI,4CAAA;EFocV;EElcM;IACI,4CAAA;EFocV;EEhcE;IACI,uBAAA;EFkcN;EE/bE;IACI,sBAAA;IACA,mBAAA;EFicN;EE/bM;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;EFicV;EE/bU;IACI,cAAA;EFicd;EE5bE;IACI,sBAAA;IACA,SAAA;EF8bN;AACF,CAAC,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
